import { LayoutDashboard, Package, Users, Target, BarChart3, Trophy, Truck, UserSquare, AlertCircle, FileText, Settings, ReceiptText, Wallet, Receipt, Users2, Banknote, Building2, Printer, Boxes, Wrench } from 'lucide-react';

export const ownerNav = [
  { path: '/owner', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/owner/products', label: 'Barang & HPP', icon: Package },
  { path: '/owner/iron-prices', label: 'Harga Besi', icon: Wrench },
  { path: '/owner/product-assets', label: 'Aset Produk', icon: Boxes },
  { path: '/owner/suppliers', label: 'Supplier', icon: Truck },
  { path: '/owner/customers', label: 'Customer', icon: UserSquare },
  { path: '/owner/employees', label: 'Daftar Karyawan', icon: Users2 },
  { path: '/owner/transactions', label: 'Riwayat Transaksi', icon: ReceiptText },
  { path: '/owner/salary', label: 'Input Gaji Karyawan', icon: Banknote },
  { path: '/owner/company-expenses', label: 'Beban Perusahaan', icon: Building2 },
  { path: '/owner/expenses', label: 'Pengeluaran', icon: Receipt },
  { path: '/owner/outstanding', label: 'Telat Pembayaran', icon: AlertCircle },
  { path: '/owner/users', label: 'Manajemen User', icon: Users },
  { path: '/owner/kpi', label: 'KPI Target', icon: Target },
  { path: '/owner/leaderboard', label: 'Leaderboard', icon: Trophy },
  { path: '/owner/reports', label: 'Laporan', icon: BarChart3 },
  { path: '/owner/print-templates', label: 'Template Cetak', icon: Printer },
  { path: '/owner/settings', label: 'Pengaturan', icon: Settings },
];

export const adminNav = [
  { path: '/admin', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/admin/suppliers', label: 'Supplier', icon: Truck },
  { path: '/admin/customers', label: 'Customer', icon: UserSquare },
  { path: '/admin/employees', label: 'Daftar Karyawan', icon: Users2 },
  { path: '/admin/products', label: 'Barang', icon: Package },
  { path: '/admin/transactions', label: 'Riwayat Transaksi', icon: ReceiptText },
  { path: '/admin/documents', label: 'Cetak Dokumen', icon: FileText },
  { path: '/admin/outstanding', label: 'Telat Pembayaran', icon: AlertCircle },
  { path: '/admin/leaderboard', label: 'Leaderboard', icon: Trophy },
  { path: '/admin/reports', label: 'Laporan Penjualan', icon: BarChart3 },
];

export const kasirNav = [
  { path: '/kasir', label: 'POS', icon: LayoutDashboard },
  { path: '/kasir/products', label: 'Barang', icon: Package },
  { path: '/kasir/customers', label: 'Customer', icon: UserSquare },
  { path: '/kasir/documents', label: 'Cetak Dokumen', icon: FileText },
  { path: '/kasir/outstanding', label: 'Telat Pembayaran', icon: AlertCircle },
  { path: '/kasir/history', label: 'Riwayat', icon: BarChart3 },
];


export const financeNav = [
  { path: '/finance', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/finance/operational', label: 'Biaya Operasional', icon: Wallet },
  { path: '/finance/reports', label: 'Laporan Pengeluaran', icon: BarChart3 },
];
